import { computed, ref } from 'vue';
import TasksAPI from 'dashboard/api/captain/tasks';

// Uma consulta por conta a cada minuto, compartilhada pelos compositores abertos.
const CACHE_TTL_MS = 60 * 1000;
const states = new Map();

const stateFor = accountId => {
  if (!states.has(accountId)) {
    states.set(accountId, {
      reason: ref(null),
      checkedAt: 0,
      request: null,
    });
  }
  return states.get(accountId);
};

export const LIA_UNAVAILABLE_REASONS = {
  NOT_CONFIGURED: 'not_configured',
  NO_CREDITS: 'no_credits',
};

/**
 * Disponibilidade da Lia na conta. Falhas na consulta não bloqueiam a Lia:
 * o backend continua recusando e explicando quando for o caso.
 * @param {import('vue').Ref<number>} accountId
 */
export function useLiaAvailability(accountId) {
  const state = computed(() => stateFor(accountId.value));
  const unavailableReason = computed(() => state.value.reason.value);
  const isUnavailable = computed(() => Boolean(unavailableReason.value));

  const refresh = ({ force = false } = {}) => {
    const current = state.value;
    if (!accountId.value) return Promise.resolve();
    if (current.request) return current.request;
    if (!force && Date.now() - current.checkedAt < CACHE_TTL_MS) {
      return Promise.resolve();
    }

    current.request = TasksAPI.availability()
      .then(({ data }) => {
        current.reason.value = data?.available ? null : data?.reason || null;
        current.checkedAt = Date.now();
      })
      .catch(() => {
        current.reason.value = null;
      })
      .finally(() => {
        current.request = null;
      });
    return current.request;
  };

  return { unavailableReason, isUnavailable, refresh };
}

export const resetLiaAvailabilityCache = () => states.clear();
